import React from 'react';
import { Poppins } from 'src/common';
import { BaseCard } from '../../styled';
import { numeralFormat } from 'src/utils/misc';

interface TileExpectedLossProps {
  expectedLoss: number;
}

export const TileExpectedLoss: React.FC<TileExpectedLossProps> = ({ expectedLoss }) => {
  return (
    <BaseCard>
      <span className="c-title">Expected Loss</span>
      <div className="content">
        <span className="description">
          The assessment expected loss represents the probability adjusted, mean loss if each risk were to manifest in
          the same year.
        </span>
      </div>
      <div style={{ flex: 1 }} />
      <Poppins weight={600} color="gp1" px={26}>
        {numeralFormat(expectedLoss)}
      </Poppins>
    </BaseCard>
  );
};
